export const generateDataAttr = (props, filter) => Object.entries(props)
    .filter(([key]) => filter && filter.includes(key))
    .reduce((output, [key, value]) => (Object.assign(Object.assign({}, output), { [`data-${key.toLowerCase()}`]: value })), {});
//# sourceMappingURL=generateDataAttr.js.map